export default __webpack_public_path__ + "static/media/vote.650eb433.gif";